import * as React from "react";
import { forwardRef } from "react";
const SvgTime = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 6, stroke: "#222" }), /* @__PURE__ */ React.createElement("path", { d: "M8 5V8L10.6667 9.33333", stroke: "#222", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTime);
export default ForwardRef;
